import type { TenantList } from '../tenant.types';
import { CompanySimpleModel } from '@repositories/companyRepository/models/CompanySimpleModel';
import { TenantSimpleModel } from './TenantSimpleModel';

export class TenantListModel {
  private readonly _dto: TenantList;
  private readonly _parentTenant: TenantSimpleModel | undefined;
  private readonly _rootTenant: TenantSimpleModel | undefined;
  private readonly _company?: CompanySimpleModel;

  constructor(dto: TenantList) {
    this._dto = dto;
    this._parentTenant = dto.parentTenant ? new TenantSimpleModel(dto.parentTenant) : undefined;
    this._rootTenant = dto.rootTenant ? new TenantSimpleModel(dto.rootTenant) : undefined;
    this._company = dto.company ? new CompanySimpleModel(dto.company) : undefined;
  }

  get originDTO(): TenantList {
    return this._dto;
  }

  get id(): string {
    return this._dto.id || '';
  }

  get tenantCode(): string {
    return this._dto.tenantCode || '';
  }

  get description(): string {
    return this._dto.description || '';
  }

  get name(): string {
    return this._dto.name || '';
  }

  get parentTenant(): TenantSimpleModel | undefined {
    return this._parentTenant;
  }

  hasParentTenant(): boolean {
    return !!this._parentTenant;
  }

  get level(): number {
    return this._dto.level || -1;
  }

  get memberCount(): number {
    return this._dto.memberCount || 0;
  }

  get subTenantCount(): number {
    return this._dto.subTenantCount || 0;
  }

  get subscriptionCount(): number {
    return this._dto.subscriptionCount || 0;
  }

  get rootTenant(): TenantSimpleModel | undefined {
    return this._rootTenant;
  }

  isCompanyTenant() {
    return !!this._company;
  }

  get company() {
    return this._company;
  }
}
